export const housekeepingDrawer = {
  close: "Cerrar",
  guest: "Huésped",

  cleaning: {
    title: "Estado de limpieza",
    lastCleaned: "Limpiada {date}",
    evidenceAlt: "evidencia",
  },

  status: {
    dirty: "Por limpiar",
    in_progress: "En proceso",
    clean: "Limpia",
    inspected: "Inspeccionada",
    out_of_service: "Fuera de servicio",
  },

  occupancy: {
    title: "Ocupación",
    aboutToLeave: "A punto de salir",
    checkIn: "Entrada {date}",
    checkOut: "Salida {date}",
    checkoutTime: "Checkout {time}",
    booking: "Reserva {code}",
    nextArrivalToday: "Próxima entrada hoy",
    fromTime: "desde {time}",
    labels: {
      vacant: "Libre",
      occupied: "Ocupada",
      departure_today: "Sale hoy",
      arrival_today: "Llega hoy",
      turnover: "Salida y entrada hoy",
    },
  },

  window: {
    windowLabel: "Ventana",
    standardSchedule: "Horario estándar",
    sub: "{label}: checkout {checkout} → entrada {checkin}",
    overdue: "Entrada vencida · prioriza esta limpieza",
    untilArrival: "{dur} para la entrada",
  },

  tasks: {
    title: "Tareas de limpieza",
    // Pluralización (vue-i18n v8 con pipes) — choiceIndex = nº de tareas pendientes
    pendingCount: "{count} pendiente | {count} pendientes",
    newPlaceholder: "Añadir una tarea (p. ej. Cambiar toallas)",
    priorityTitle: "Prioridad",
    dateTitle: "Fecha",
    timeTitle: "Hora (opcional)",
    assignTitle: "Asignar a",
    assignAllOption: "Todos (limpieza y mantenimiento)",
    byRole: "Por rol",
    wholeRoleSuffix: "(todo el rol)",
    people: "Personas",
    add: "Añadir",
    adding: "Añadiendo…",
    loading: "Cargando tareas…",
    empty: "Sin tareas. Añade la primera arriba.",
    markPending: "Marcar pendiente",
    markDone: "Marcar hecha",
    priorityDotTitle: "Prioridad {priority}",
    delete: "Eliminar",
  },

  enc: {
    late: "Venció",
    title: "Encargos para esta habitación",
    what: "Cosas puntuales además de la limpieza: reponer algo, revisar una avería, un detalle para el huésped. Lo verá quien vaya a la habitación y lo marcará al hacerlo.",
    protocolNote: "Los pasos de la limpieza están en el protocolo, arriba. Aquí solo lo extra.",
    emptyTitle: "No hay encargos pendientes",
    emptyExamples: "Por ejemplo: «Cambiar la bombilla del baño» o «Dejar una botella de vino de bienvenida».",
    newBtn: "Nuevo encargo",
    qWhat: "¿Qué hay que hacer?",
    whatPlaceholder: "Escríbelo con tus palabras…",
    suggestions: "Reponer café y azúcar | Cambiar una bombilla | Revisar el aire acondicionado | Dejar toallas extra | Revisar el wifi | Detalle de bienvenida",
    qWhen: "¿Cuándo?",
    today: "Hoy",
    tomorrow: "Mañana",
    otherDay: "Otro día",
    anyDay: "Sin fecha",
    atTime: "A una hora concreta",
    qWho: "¿Quién lo hace?",
    whoever: "Quien vaya a limpiar",
    isUrgent: "Es urgente",
    urgentHint: "Saldrá destacado y se avisará antes.",
    urgent: "Urgente",
    preview: "«{what}» · {when} · {who}",
    cancel: "Cancelar",
    save: "Guardar encargo",
    showDone: "Ver {count} hecho | Ver {count} hechos",
    hideDone: "Ocultar los hechos",
    confirmDelete: "¿Borrar el encargo «{what}»?",
  },

  priority: {
    low: "Baja",
    normal: "Normal",
    high: "Alta",
    urgent: "Urgente",
  },

  roles: {
    limpieza: "Limpieza",
    mantenimiento: "Mantenimiento",
    propietario: "Propietario",
  },

  assignee: {
    assigned: "Asignada",
    all: "Todos",
  },
};
